export const SITESETUP_ASSIGN_ITEMS_BIDGROUP =
  'SITESETUP_ASSIGN_ITEMS_BIDGROUP';
export const SITESETUP_ASSIGN_ITEMS_LOADING = 'SITESETUP_ASSIGN_ITEMS_LOADING';
export const SITESETUP_ASSIGN_ITEMS_ITEMGROUP =
  'SITESETUP_ASSIGN_ITEMS_ITEMGROUP';
export const SITESETUP_ASSIGN_ITEMS_ACCT_CATEGORY =
  'SITESETUP_ASSIGN_ITEMS_ACCT_CATEGORY';
export const SITESETUP_ASSIGN_ITEMS_VENDOR = 'SITESETUP_ASSIGN_ITEMS_VENDOR';
export const SITESETUP_ASSIGN_ITEMS_STORAGE_LOCATION =
  'SITESETUP_ASSIGN_ITEMS_STORAGE_LOCATION';
export const SITESETUP_UPDATE_ASSIGN_ITEMS_DATA =
  'SITESETUP_UPDATE_ASSIGN_ITEMS_DATA';
export const SITESETUP_CHECKALL_ASSIGN_ITEMS_DATA =
  'SITESETUP_CHECKALL_ASSIGN_ITEMS_DATA';
export const SITESETUP_ASSIGN_ORDERING_ITEMS_DATA =
  'SITESETUP_ASSIGN_ORDERING_ITEMS_DATA';
export const SITESETUP_SAVE_ORDERING_ITEMS = 'SITESETUP_SAVE_ORDERING_ITEMS';
export const SITESETUP_RESET_ASSIGN_ITEMS_ON_CLOSE =
  'SITESETUP_RESET_ASSIGN_ITEMS_ON_CLOSE';
export const SITESETUP_RESET_ASSIGN_AND_MODIFIED_ITEMS =
  'SITESETUP_RESET_ASSIGN_AND_MODIFIED_ITEMS';
export const SITESETUP_ASSIGN_ITEMS_END_SUBMIT =
  'SITESETUP_ASSIGN_ITEMS_END_SUBMIT';
export const SITESETUP_ASSIGN_ITEMS_BEGIN_SUBMIT =
  'SITESETUP_ASSIGN_ITEMS_BEGIN_SUBMIT';

export const SITESETUP_ASSIGN_ITEMS_BIDGROUP_ERROR =
  'SITESETUP_ASSIGN_ITEMS_BIDGROUP_ERROR';
export const SITESETUP_ASSIGN_ITEMS_ITEMGROUP_ERROR =
  'SITESETUP_ASSIGN_ITEMS_ITEMGROUP_ERROR';
export const SITESETUP_ASSIGN_ITEMS_ACCT_CATEGORY_ERROR =
  'SITESETUP_ASSIGN_ITEMS_ACCT_CATEGORY_ERROR';
export const SITESETUP_ASSIGN_ITEMS_STORAGE_LOCATION_ERROR =
  'SITESETUP_ASSIGN_ITEMS_STORAGE_LOCATION_ERROR';
export const SITESETUP_ASSIGN_ITEMS_DATA_ERROR =
  'SITESETUP_ASSIGN_ITEMS_DATA_ERROR';
export const SITESETUP_ASSIGN_ITEMS_VENDOR_ERROR =
  'SITESETUP_ASSIGN_ITEMS_VENDOR_ERROR';
export const SITESETUP_SAVE_ORDERING_ITEMS_ERROR =
  'SITESETUP_SAVE_ORDERING_ITEMS_ERROR';
export const SITESETUP_CLEAR_ASSIGN_ITEMS_ERROR_SUCCESS =
  'SITESETUP_CLEAR_ASSIGN_ITEMS_ERROR_SUCCESS';
export const SITESETUP_ASSIGN_ITEMS_SUBMIT = 'SITESETUP_ASSIGN_ITEMS_SUBMIT';
export const SITESETUP_ASSIGN_ITEMS_CLEAR = 'SITESETUP_ASSIGN_ITEMS_CLEAR';



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/assignItems/types.js